import WhatsappIcon from "@/Assets/images/whatsapp-icon.png";
import { Popover, PopoverOrigin } from "@mui/material";
import { InaccessibleTabMessageProps } from "../../Types";
import { ArrowDropDown } from "@material-ui/icons";
import { useDispatch, useSelector } from "react-redux";
import { getRequestStaffPermission } from "@/Redux/Actions";
import { RootState } from "@/Redux/Reducers";

export function InaccessibleTabMessage(props: InaccessibleTabMessageProps) {
  const { anchorEl, setAnchorEl, requiredPermission } = props;
  const dispatch = useDispatch();

  const ownerPhone = useSelector((state: RootState) => state.storeReducer.store?.owner?.phone);

  function handlePermissionRequestClick() {
    dispatch(
      getRequestStaffPermission({
        permission: requiredPermission,
        staff_phone: ownerPhone,
      }),
    );
  }

  return (
    <Popover
      anchorEl={anchorEl}
      open={!!anchorEl}
      anchorOrigin={
        {
          vertical: "top",
          horizontal: "right",
        } as PopoverOrigin
      }
      transformOrigin={{
        vertical: "top",
        horizontal: "left",
      }}
      classes={{
        paper: `!tw-overflow-visible !tw-p-0 !tw-mb-[8px] !tw-shadow-[1px_2px_8px_0px_#00000026] !tw-translate-x-[8px] !tw-rounded-[12px]`,
        root: "!tw-static !tw-w-fit !tw-h-fit",
      }}
      onClose={() => setAnchorEl(null)}
    >
      <div className="tw-z-[9999] tw-w-[276px] !tw-rounded-[12px]  tw-bg-white tw-p-[16px] tw-text-black">
        <ArrowDropDown
          className="tw-absolute tw-right-full tw-top-[2px] tw-translate-x-[42%] tw-rotate-90 tw-text-white"
          fontSize="large"
        />
        <div className="tw-mb-[16px] tw-text-sm tw-font-normal tw-text-[#111C36]">
          You don’t have permission for this feature, request permission from Store owner
        </div>
        <button
          onClick={handlePermissionRequestClick}
          className="br-none tw-flex tw-w-full tw-items-center tw-justify-center tw-gap-[10px] tw-rounded tw-bg-[#111C36] tw-py-[10px]  tw-font-normal tw-text-white"
        >
          <img className="tw-h-[20px] tw-w-[20px]" src={WhatsappIcon} alt=""></img>
          <div className="tw-text-[13px]/[20px] tw-font-medium">Request Permission</div>
        </button>
      </div>
    </Popover>
  );
}
